import { Component } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment';
import { debounceTime, filter, Subject } from 'rxjs';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { EventService } from 'src/app/services/core/event/event.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { timeZone } from 'src/app/utils/utils.common';

@UntilDestroy()
@Component({
  selector: 'app-list-event',
  templateUrl: './list-event.component.html',
  styleUrls: ['./list-event.component.css']
})
export class ListEventComponent {
  selectedStatus: any = '';
  events: any = [];
  totalPages = 0;
  totalResults = 0;
  currentPage: number = 1
  numberOfRecords = NUMBER_OF_RECORDS;
  search: any
  private searchSubject = new Subject<string>();
  status = true;
  todayDate: any = [];
  user: any;
  timeZone: any = timeZone;
   currentDate: any = moment().tz(this.timeZone).toISOString()
  userPermission = UserPermission
  constructor(private eventService: EventService,
    private sharedDataService: SharedDataService
  ) {

  }

  ngOnInit() {
    this.getUser();
    this.getEvent(this.currentPage);
    this.initializeSearch();
  }

    getUser() {
        this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
          if (data) {
            this.user = data;
            if (this.user.timeZone) {
              this.timeZone = this.user.timeZone;
            }
            this.todayDate = [
              moment().tz(this.timeZone).startOf("day"),
              moment().tz(this.timeZone).endOf("day"),
            ];
          }
    
        })
      }

  getEvent(page: number) {
    const queryparams:any = {
      limit: 50,
      page,
      time: [this.todayDate[0].toISOString(), this.todayDate[1].toISOString()],
      isActive: this.status,
      sortBy: 'createdAt:desc',
    };
    if (this.search) {
      queryparams.search = this.search.trim();
    }
    this.eventService.get(queryparams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data.results) {
         this.events = data.results;
        this.totalPages = data.totalPages;
        this.totalResults = data.totalResults;
      }
    });
  }
  
  initializeSearch() {
    this.searchSubject
      .pipe(
        debounceTime(500),
        filter((search: any) => !search || search.length >= 3)
      )
      .subscribe(() => {
        this.currentPage = 1;
        this.getEvent(this.currentPage);
      });
  }

  onSearchInput() {
    this.searchSubject.next(this.search);
  }

  onDateChange(event: any) {
    this.todayDate = [
      event[0],
      event[1].endOf("day"),
    ];
    this.currentPage = 1;
    this.getEvent(this.currentPage);
  }


  onPageChange(page: number) {
    this.currentPage = page;
    this.getEvent(page);
  }

  onSelectStatus(event: any): void {
    this.status = event.target.value
    this.getEvent(this.currentPage = 1);
  }

}
